export default "__VITE_ASSET__BkfA5xS0__"